import {Component, OnInit} from '@angular/core';
import {UsersService} from './users.service';
import {User} from '../../models/beans';
import {AppComponent} from 'app/app.component';
import {MessageService} from 'primeng/api';
import {Router, ActivatedRoute} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {ListComponent, ItemComponent} from 'app/commons/list.component';
import {LoginService} from '../login/login.service';
import {AppBreadcrumbService} from '../app.breadcrumb.service';


@Component({
    selector: 'afm-users',
    templateUrl: '../commons/items.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class UsersComponent implements OnInit {

    title : string = 'Users Management';
    
    constructor() {}
    
    ngOnInit() {
    }
}
@Component({
    templateUrl: '../commons/list.component.html',
    styleUrls: ['../commons/items.component.scss']
})
export class UserListComponent extends ListComponent implements OnInit {
    
    roles: any[] = [];
    
    static USER_GROUPS_KEY :any  = {"USER":"Utilisateur",
                        "ADMIN": "Administrateur partenaire",
                        "BACKENDADMIN": "Administrateur plateforme",
                        "SUPERADMIN": "Super administrator"
                        };
  
    constructor(private cs: ConfirmationService, private ms: MessageService,private s: UsersService, private a: AppComponent, private bs: AppBreadcrumbService) {
        super(cs,ms,s,a,bs);
    }

    ngOnInit() {
        this.title = 'List of Users';
        super.ngOnInit();
    }
    getPath(){
        return 'user';
    }
    static formatGroup(key:string) : string{
        return key in UserListComponent.USER_GROUPS_KEY ? UserListComponent.USER_GROUPS_KEY[key] : key;
    }

    getCols(){
        return [
            { field: 'id', header: 'ID' ,placeHolder:'' ,width : '60px'},
            { field: 'login', header: 'Login',placeHolder:'',width : '150px' ,filtered : true,type : 'text'},
            { field: 'name', header: 'Name',placeHolder:'',filtered : true,type : 'text' },
            { field: 'partnerId.name', header: 'Partner',placeHolder:'',filtered : true,type : 'text' },
            { field: 'group', header: 'Group' ,placeHolder:'',format : UserListComponent.formatGroup,filtered : true,type : 'text'}
        ];
    }

}
@Component({
    templateUrl: './user.component.html',
    styleUrls: ['./users.component.css','../commons/items.component.scss']
})
export class UserComponent  extends ItemComponent implements OnInit  {

    roles: any[] = [];

    password: string;

    me : boolean = false;

    groupKeys:  any[] = [{"value": "USER", "label": "Utilisateur"},
    {"value": "ADMIN", "label": "Administrateur partenaire"},
    {"value": "BACKENDADMIN", "label": "Administrateur plateforme"}];


    constructor(private ms: MessageService, private s: UsersService,
        private a: AppComponent, private rt: Router, private r: ActivatedRoute,public loginService:LoginService, private bs: AppBreadcrumbService) {
        super(ms,s,a,rt,r,bs);
    }

    ngOnInit() {
        super.ngOnInit();
        this.s.getRoles().then(data => this.roles = data);
        }
    
    prepareEdit(){
        this.item.password = '';
        this.password = '';
    }
    
    addCheck(){
        if ((!this.edit && this.item.password != this.password) ||
            (this.edit && (this.item.password || this.password) && this.item.password != this.password)) {
            this.ms.add({severity: 'error', summary: 'Erreur Password', detail: 'the two passwords dont not match'});
            return false;
        }
        return true;
    }
    
    getPath(){
        return 'users';
    }
    getSuccessMessage(){
        return 'User save with success';
    }

}
